const isTesting = import.meta.env.VITE_APP_MODE != "production";

export const workspaceHost = isTesting
  ? "workspace.zid.dev"
  : "workspace.zid.team";

export const workspaceUrl = `https://${workspaceHost}`;
